import { rootApi } from "@/services/api/api";
import type { GetProfileResponse, UpdateProfileRequest } from "../types";

const profileApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query<GetProfileResponse, void>({
      query: () => ({
        url: "/profile",
        method: "GET",
      }),
      providesTags: ["profile"],
    }),
    updateProfile: build.mutation<void, UpdateProfileRequest>({
      query: (data) => ({
        url: "/profile",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["profile"],
    }),
  }),
});

export const { useGetProfileQuery, useUpdateProfileMutation } = profileApi;
